import { render, staticRenderFns } from "./PageListSliderItem.vue?vue&type=template&id=0341b717"
import script from "./PageListSliderItem.vue?vue&type=script&lang=js"
export * from "./PageListSliderItem.vue?vue&type=script&lang=js"
import style0 from "./PageListSliderItem.vue?vue&type=style&index=0&id=0341b717&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports